<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-01 15:13:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-26 17:35:13
-->
<template>
  <v-card>
    <v-card-text>
      <!-- <mrc_ess_mytree
        ref="roleTree"
        :uuids="propsParams"
        :list="treeList"
        :disabled="disabled"
        :isload="isload"
      >
      </mrc_ess_mytree> -->
      <v-card-subtitle class="px-0 pt-0 pb-4">
        <div class="is_flex_between mx-10 text--secondary">
          <v-sheet class="d-flex align-center text--secondary">
            <span class="px-1">{{ $t("label_product") }}</span>/<span class="px-1">{{ $t("label_The_module") }}</span>/
            <span class="d-flex align-center px-1 text--secondary">
              <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                               icon-class="diamond02"></mrc_ess_svgIcon>{{ $t("label_function") }}
            </span>/
            <span class="d-flex align-center px-1 text--secondary">
              <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                               icon-class="mouseButton"></mrc_ess_svgIcon>
              {{ $t("label_button") }}
            </span>
          </v-sheet>
          <span class="mr-12">{{ $t("label_clientType") }}</span>
        </div>
      </v-card-subtitle>
      <v-treeview v-model="ids"
                  style="border:1px solid #e8e8e8;border-radius:4px;"
                  item-children="sub"
                  expand-icon="arrow_drop_down"
                  item-disabled="disabled"
                  return-object
                  item-key="uuid"
                  selectable
                  selected-color="primary"
                  :items="treeList">
        <template v-slot:label="{ item }">
          <div v-if="disabled"
               style="position:absolute;z-index:10;width:100%;height:50%;margin-left:-30px;"></div>
          <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                           icon-class="diamond02"
                           v-if="item.type == 3"></mrc_ess_svgIcon>
          <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px;color:rgba(0,0,0,.6)"
                           icon-class="mouseButton"
                           fill="rgba(0, 0, 0, 0.6)"
                           v-if="item.type == 4"></mrc_ess_svgIcon>
          {{ INT(item.names) }}
        </template>
        <template v-slot:append="{ item }">
          <div class="pr-8 d-flex"
               v-if="item.type != 1">
            <template v-for="item1 in splitINT(item.client_type_uuid)">
              <mrc_ess_svgIcon :key="item1"
                               style="font-size: 24px;margin-right: 5px"
                               :icon-class="item1"></mrc_ess_svgIcon>
            </template>
            <template v-for="(item1, index) in 6 -
                splitINT(item.client_type_uuid).length">
              <i style="font-size: 24px;margin-right: 5px;line-height:44px;"
                 class="material-icons text--secondary"
                 :key="index">maximize</i>
            </template>
          </div>
        </template>
      </v-treeview>
    </v-card-text>
    <mrc_ess_submitBtn v-if="!disabled"
                       @cancel="cancel"
                       @success="success"
                       :loading="loading"
                       :cancelText="cancelText || $t('label_cancel')"
                       :successText="successText || $t('label_submit')"></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { func_list } from "@/service/api/role"
export default {
  components: {},
  props: {
    loading: {
      default: false,
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    propsParams: {
      type: Array,
      default: () => [],
    },
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
  },
  data () {
    return {
      isload: false,
      treeList: [],
      ids: [],
    }
  },
  created () { },
  async mounted () {
    this.isload = false
    await this.getFuncList()

    this.propsParams.forEach((item) => {
      item.button_uuid.split(",").forEach((it) => {
        this.ids.push({
          uuid: it,
          uuid1: item.function_uuid,
        })
      })
    })
    this.isload = true
  },
  methods: {
    eleTree () {
      return this.filterData("uuid1", this.ids)
      // return this.$refs.roleTree.getCheckData()
    },
    /**
     * @description: 获取树结构
     * @param {type}
     * @return:
     * @author: lwq
     */

    async getFuncList () {
      const list = await func_list({
        client_role_uuid: this.$store.state.userData.client_role_uuid,
        role_uuid:
          this.$store.state.userData.userType == 1
            ? this.$store.state.uuid
            : "",
      })
      if (list.code == 200) {
        this.treeList = list.data
      }
    },
    cancel () {
      this.$emit("cancel")
    },
    success () {
      this.$emit("success", this.filterData("uuid1", this.ids))
      // this.$emit("success", this.$refs.roleTree.getCheckData())
    },
    //arr为传入函数的目标数组，根据传入的key重组数组
    filterData (key, arr) {
      let map = {},
        dest = []
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i]
        if (!map[ai[key]]) {
          dest.push({
            function_uuid: ai[key],
            button_uuid: [ai["uuid"]],
          })
          map[ai[key]] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj["function_uuid"] == ai[key]) {
              dj.button_uuid.push(ai.uuid)
              break
            }
          }
        }
      }
      dest.forEach((item) => (item.button_uuid = item.button_uuid.join(",")))
      return dest
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped></style>
